export const LOADER_DELAY = 300;